import { useQuery } from "@tanstack/react-query";
import API from "@/config/api";
import type { Brand } from "@/types/brand";

/**
 * Custom query hook to fetch a single brand by numeric ID or slug string.
 * @param identifier - Brand ID (number) or Brand Slug (string)
 */
export function useSingleBrand(identifier: number | string | undefined | null) {
  const isNumber = typeof identifier === "number";
  const isString =
    typeof identifier === "string" && identifier.trim().length > 0;

  // Determine endpoint based on type
  const endpoint = isNumber
    ? `/brands/${identifier}`
    : isString
      ? `/brands/slug/${identifier}`
      : "";

  return useQuery({
    queryKey: ["brand", identifier],
    queryFn: async () => {
      const { data } = await API.main.get<{ data: Brand }>(endpoint);
      return data.data;
    },
    enabled: Boolean(identifier) && (isNumber || isString),
  });
}
